import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/json'

// Add a global request interceptor to set 'x-source' header for SSO users
axios.interceptors.request.use(
  function (config) {
    try {
      config.headers['x-app'] = 'UPA'
    } catch (e) {
      // fail silently, don't block request
      console.log(e)
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default axios
